import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProductDetails.css"; // Custom styles
import { NavLink } from "react-router-dom";
import { FaFilter, FaTimes, FaChevronDown, FaPhoneAlt } from "react-icons/fa";
import { User, Mail, Phone, Square } from "lucide-react";
import "./Products.css";
import productData from "../data/productData";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { FaArrowDown } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";
import FullScreenLoader from "../components/FullScreenLoader";


function ProductDetails() {
    const swiperRef = useRef(null);

    //
    const [showFormPopup, setShowFormPopup] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);


    const handleReachOut = (context) => {
        setShowFormPopup(true);
        setFormSubmitted(false); // Reset form submission when opening popup
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // You can add form validation or API call here
        setFormSubmitted(true);
    };


    // 

    // Form PHP
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [pendingBrochure, setPendingBrochure] = useState(null);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        // Optional: basic validation
        if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
            setResponseMessage("Please fill in all fields.");
            setLoading(false);
            return;
        }

        const formBody = new URLSearchParams(formData).toString();

        try {
            const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/contact-form-premier-pumps.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formBody,
            });

            const result = await response.json();

            if (result.status === "success") {
                setResponseMessage("Message sent successfully! ✅");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    message: "",
                });
                if (pendingBrochure) {
                    const brochureToDownload = pendingBrochure;
                    setShowFormPopup(false);
                    setPendingBrochure(null);
                    triggerBrochureDownload(brochureToDownload);
                    const formId = brochureToDownload.formId || "product";
                    navigate(`/thank-you?formId=${encodeURIComponent(formId)}`, {
                        state: {
                            brochureUrl: brochureToDownload.url,
                            brochureName: brochureToDownload.filename,
                        },
                    });
                } else {
                    const formId = toFormId(product?.name);
                    setShowFormPopup(false);
                    setShowThankYouPopup(false);
                    navigate(`/thank-you?formId=${encodeURIComponent(formId)}`);
                }
            } else {
                setResponseMessage("Error: " + result.message);
            }
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    // Form PHP

    const toFormId = (name) => {
        const base = String(name || "")
            .trim()
            .toLowerCase()
            .replace(/&/g, "and")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/(^-|-$)/g, "");
        return base || "product";
    };

    const resolveBrochureFilename = (brochureUrl, brochureName) => {
        if (brochureName) return brochureName;
        if (!brochureUrl) return "brochure.pdf";
        const cleanUrl = String(brochureUrl).split(/[?#]/)[0];
        const lastSegment = cleanUrl.split("/").pop();
        return decodeURIComponent(lastSegment || "brochure.pdf");
    };

    const openBrochureForm = (brochureUrl, brochureName, productName) => {
        setResponseMessage("");
        setPendingBrochure({
            url: brochureUrl,
            filename: resolveBrochureFilename(brochureUrl, brochureName),
            formId: toFormId(productName),
        });
        setShowFormPopup(true);
    };

    const closeBrochureForm = () => {
        setResponseMessage("");
        setShowFormPopup(false);
        setPendingBrochure(null);
    };

    const triggerBrochureDownload = (brochure) => {
        if (!brochure?.url) return;
        const link = document.createElement("a");
        link.href = brochure.url;
        if (brochure.filename) {
            link.setAttribute("download", brochure.filename);
        }
        document.body.appendChild(link);
        link.click();
        link.remove();
    };



    const { category } = useParams();
    const navigate = useNavigate();

    // All useState hooks at the top
    const [activeTab, setActiveTab] = useState("description");
    const [showSidebar, setShowSidebar] = useState(false);
    const [filteredProducts, setFilteredProducts] = useState(productData);
    const [activeCategory, setActiveCategory] = useState(category || "all");
    const [activeThumb, setActiveThumb] = useState(0);

    const product = productData.find((p) => p.category === category);

    // Sync activeCategory with URL param
    useEffect(() => {
        setActiveCategory(category || "all");
        if (category) {
            setFilteredProducts(productData.filter((p) => p.category === category));
        } else {
            setFilteredProducts(productData);
        }
    }, [category]);

    useEffect(() => {
        setActiveThumb(0);
    }, [category]);

    const defaultOpenSection =
        product.sections.find(section => section.defaultOpen)?.id || null;

    const [openId, setOpenId] = useState("description");


    const toggle = (id) => {
        setOpenId(openId === id ? null : id);
    };

    // Early return after hooks
    if (!product && category) return <div className="text-center mt-5">Product not found</div>;

    const handleMouseEnter = () => {
        const swiper = swiperRef.current;
        if (swiper && swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.stop();
        }
    };

    const handleMouseLeave = () => {
        const swiper = swiperRef.current;
        if (swiper && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
        }
    };




    const toggleSidebar = () => setShowSidebar(!showSidebar);

    const handleFilter = (selectedCategory) => {
        setActiveCategory(selectedCategory);
        setShowSidebar(false);

        if (selectedCategory === "all") {
            setFilteredProducts(productData);
            navigate('/products');
        } else {
            setFilteredProducts(productData.filter((product) => product.category === selectedCategory));
            navigate(`/product-details/${selectedCategory}`);
        }
    };




    return (
        <div className="container p-0">
            {loading && <FullScreenLoader label="Sending..." />}
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
                <div className="d-flex justify-content-between container">
                    <h5 className="fw-bold">Products</h5>
                    <ol className="breadcrumb fs-sm-14">
                        <li className="breadcrumb-item">
                            <NavLink to="/" className="text-dark">Home</NavLink>
                        </li>
                        <li className="breadcrumb-item">
                            <NavLink to="/products" className="text-dark">Products</NavLink>
                        </li>
                        <li className="breadcrumb-item active text-primary fw-bold" aria-current="page">
                            {product.name}
                        </li>
                    </ol>
                </div>
            </nav>

            <div className="container-fluid">
                <div className="container p-0">
                    <div className="row">
                        {/* Left Sidebar */}
                        <div className={`col-lg-3 col-md-3 sidebar  ${showSidebar ? "show" : ""}`}>
                            <div className="py-lg-0 py-4">
                                {/* Close Icon */}
                                <div className="close-icon d-lg-none" onClick={toggleSidebar}>
                                    <FaTimes size={24} />
                                </div>

                                <ul className="list-group product-filter">
                                    <li
                                        className={`list-item ${activeCategory === "all" ? "active" : ""}`}
                                        onClick={() => handleFilter("all")}
                                    >
                                        All Products
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pv" ? "active" : ""}`}
                                        onClick={() => handleFilter("pv")}
                                    >
                                        PV Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "premier" ? "active" : ""}`}
                                        onClick={() => handleFilter("premier")}
                                    >
                                        PREMIER Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "ps" ? "active" : ""}`}
                                        onClick={() => handleFilter("ps")}
                                    >
                                        PVSC Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pvxl" ? "active" : ""}`}
                                        onClick={() => handleFilter("pvxl")}
                                    >
                                        PVXL Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "p2be" ? "active" : ""}`}
                                        onClick={() => handleFilter("p2be")}
                                    >
                                        P2BE Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "p501" ? "active" : ""}`}
                                        onClick={() => handleFilter("p501")}
                                    >
                                        P501 Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pws" ? "active" : ""}`}
                                        onClick={() => handleFilter("pws")}
                                    >
                                        PWS Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pa" ? "active" : ""}`}
                                        onClick={() => handleFilter("pa")}
                                    >
                                        PA Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pat" ? "active" : ""}`}
                                        onClick={() => handleFilter("pat")}
                                    >
                                        PAT Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "pshr" ? "active" : ""}`}
                                        onClick={() => handleFilter("pshr")}
                                    >
                                        PSHR Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "ptc" ? "active" : ""}`}
                                        onClick={() => handleFilter("ptc")}
                                    >
                                        PTC Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "plh" ? "active" : ""}`}
                                        onClick={() => handleFilter("plh")}
                                    >
                                        PLH Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "wxp" ? "active" : ""}`}
                                        onClick={() => handleFilter("wxp")}
                                    >
                                        WXP Series
                                    </li>
                                    <li
                                        className={`list-item ${activeCategory === "p9000" ? "active" : ""}`}
                                        onClick={() => handleFilter("p9000")}
                                    >
                                        P9000
                                    </li>
                                </ul>

                                <div className="subscribe-box mt-4">
                                    <h5 className="fw-bold text-blue mb-4 text-center">Reach out to us !</h5>
                                    <div className="form-container">
                                        {!formSubmitted ? (
                                            <form onSubmit={handleSubmit}>
                                                <div className="input-group flex-column">

                                                    {/* Full Name */}
                                                    <label className="fw-medium">
                                                        Name <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="input-wrapper rounded-20">
                                                        <div className="d-flex align-items-center">
                                                            <User size={20} className="input-icon text-blue me-2" />
                                                            <input
                                                                name="fullName"
                                                                type="text"
                                                                placeholder="Enter your name"
                                                                className="form-control border-start rounded-0 ps-2"
                                                                required
                                                                value={formData.fullName}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <label className="fw-medium">
                                                        Email <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="input-wrapper rounded-20">
                                                        <div className="d-flex align-items-center">
                                                            <Mail size={20} className="input-icon text-blue me-2" />
                                                            <input
                                                                name="email"
                                                                type="email"
                                                                placeholder="Enter your email"
                                                                className="form-control border-start rounded-0 ps-2"
                                                                required
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Phone */}
                                                    <label className="fw-medium">Phone</label>
                                                    <div className="input-wrapper rounded-20">
                                                        <div className="d-flex align-items-center">
                                                            <Phone size={20} className="input-icon text-blue me-2" />
                                                            <input
                                                                name="phone"
                                                                type="tel"
                                                                placeholder="Enter your phone number"
                                                                className="form-control border-start rounded-0 ps-2"
                                                                value={formData.phone}
                                                                onChange={handleChange}
                                                                onKeyDown={(e) => {
                                                                    const allowedKeys = [
                                                                        "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                                                        "Tab", "Home", "End", "+", "-", "(", ")", " "
                                                                    ];
                                                                    const isNumber = /^[0-9]$/.test(e.key);
                                                                    const isAllowed = allowedKeys.includes(e.key);
                                                                    if (!isNumber && !isAllowed) e.preventDefault();
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Message */}
                                                    <label className="fw-medium mt-3">Message</label>
                                                    <div className="input-wrapper rounded-20">
                                                        <textarea
                                                            name="message"
                                                            placeholder="Your Message"
                                                            rows="4"
                                                            className="form-control rounded-0 ps-2"
                                                            required
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Submit Button */}
                                                    <div className="d-flex justify-content-center">
                                                        <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                                                            {loading ? "Sending..." : "Submit"}
                                                        </button>
                                                    </div>
                                                </div>

                                                {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                                            </form>
                                        ) : (
                                            <div className="text-center p-4">
                                                <p>Thank you for reaching out! We'll get back to you soon.</p>
                                                <button
                                                    className="btn btn-primary mt-3 px-4"
                                                    onClick={() => {
                                                        setFormSubmitted(false);
                                                        setShowThankYouPopup(false);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Content Section */}
                        <div className="col-lg-9 product-content">

                            <div className="row p-lg-5 pt-lg-3 p-2">
                                {/* CONTACT BAR */}
                                <div className="product-contact my-3">
                                    <a href="tel:(256)-294-1357" className="contact-pill">
                                        <FaPhoneAlt className="me-2" size={14} />
                                        OFFICE : (256)-294-1357
                                    </a>
                                </div>
                                <div className="product-detail-img p-md-5 p-3 position-relative">

                                    <div className="row justify-content-between flex-wrap-reverse">
                                        <div className="col-md-4 text-center">
                                            <h2 className="mb-4 text-blue">{product.name}</h2>
                                        </div>

                                        <div className="col-md-8">
                                            <div className="product-detail-img-right text-start">
                                                <img
                                                    src={product.image}
                                                    alt={product.name}
                                                    className="img-fluid w-75 p-3 mt-md-0 mt-4"
                                                />

                                                <div className="product-detail-img-right-btn position-absolute">
                                                    <a
                                                        href={product.brochure}
                                                        className="contact-pill mt-3 fs-7 fs-sm-10"
                                                        download={product.brochureName}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            openBrochureForm(
                                                                product.brochure,
                                                                product.brochureName,
                                                                product.name
                                                            );
                                                        }}
                                                    >
                                                        Download Brochure
                                                        <FaChevronDown className="ms-2" size={14} />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-title my-4">
                                    <h1 className=" text-blue fs-5 fw-semibold">{product.title}</h1>
                                </div>
                                <div className=" d-flex justify-content-start gap-2">
                                    {[0].map((index) => (
                                        <img
                                            key={index}
                                            src={product.image}
                                            alt={`thumb-${index}`}
                                            width="100"
                                            className={`img-thumbnail rounded-0 p-2 ${activeThumb === index ? "border-primary border" : ""
                                                }`}
                                            onClick={() => setActiveThumb(index)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    ))}
                                </div>


                                {/* Filter Icon - Toggles Sidebar */}
                                <div className="d-lg-none filter-icon mt-3 position-fixed" onClick={toggleSidebar}>
                                    <FaFilter size={24} />
                                </div>


                                {/* ACCORDIAN SECTION */}
                                {/* <div className="product-accordion">
                                    <div className="accordion" id="productAccordion">
                                        {product.sections.map((section) => {
                                            const collapseId = `collapse-${section.id}`;
                                            const headingId = `heading-${section.id}`;
                                            const isOpen = section.defaultOpen === true;

                                            return (
                                                <div className="accordion-item border-0 shadow-sm mb-3 rounded-3 overflow-hidden" key={section.id}>
                                                    <h2 className="accordion-header m-0" id={headingId}>
                                                        <button
                                                            className={`accordion-button fw-semibold fs-5 px-4 py-3 ${!isOpen ? 'collapsed' : ''}`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#${collapseId}`}
                                                            aria-expanded={isOpen}
                                                            aria-controls={collapseId}
                                                        >
                                                            {section.title}
                                                        </button>
                                                    </h2>
                                                    <div
                                                        id={collapseId}
                                                        className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                                                        aria-labelledby={headingId}
                                                        data-bs-parent="#productAccordion"
                                                    >
                                                        <div className="accordion-body px-4 py-4 bg-white">
                                                            {section.id === 'description' || section.id === 'constructional-features' ? (
                                                                <div className="text-muted lh-lg" dangerouslySetInnerHTML={{ __html: section.content }} />
                                                            ) : section.id === 'applications' ? (
                                                                <div className="row g-3">
                                                                    {section.content.map((app, i) => (
                                                                        <div className="col-12" key={i}>
                                                                            <div className="card border h-100 shadow-none">
                                                                                <div className="card-body p-4">
                                                                                    <h6 className="card-title fw-bold mb-3 text-primary">{app.industry}</h6>
                                                                                    <p className="card-text text-muted mb-0">{app.description}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div> */}

                                {/* CUSTOM ACCORDION */}
                                <div className="custom-accordion mt-3 mt-md-5">
                                    {product.sections
                                        .filter((section) => section.id !== "why-choose")
                                        .map((section) => {
                                            const isOpen = openId === section.id;

                                            return (
                                                <div
                                                    key={section.id}
                                                    className={`custom-accordion-item mb-3 ${isOpen ? "open" : ""}`}
                                                >
                                                    {/* HEADER */}
                                                    <button
                                                        type="button"
                                                        className="custom-accordion-header text-blue border"
                                                        aria-expanded={isOpen}
                                                        onClick={() =>
                                                            setOpenId(prev => (prev === section.id ? null : section.id))
                                                        }
                                                    >
                                                        <span className="accordion-title">{section.title}</span>

                                                        {/* ARROW */}
                                                        <span className={`arrow-icon ${isOpen ? "rotate" : ""}`} />
                                                    </button>

                                                    {/* BODY */}
                                                    <div
                                                        className={`custom-accordion-body-wrapper border ${isOpen ? "open" : ""}`}
                                                    >
                                                        {isOpen && (
                                                            <div className="custom-accordion-body">
                                                                {["description", "constructional-features", "why-choose"].includes(section.id) ? (
                                                                    <div
                                                                        className="text-muted lh-lg"
                                                                        dangerouslySetInnerHTML={{ __html: section.content }}
                                                                    />
                                                                ) : section.id === "applications" ? (
                                                                    <div className="row g-3">
                                                                        {section.content.map((app, i) => (
                                                                            <div className="col-12 p-0" key={i}>
                                                                                <div className="card border shadow-none h-100">
                                                                                    <div className="row g-0 h-100 align-items-center">
                                                                                        <div className="col-lg-8">
                                                                                            <div className="card-body">
                                                                                                <h6 className="fw-bold text-primary mb-2" dangerouslySetInnerHTML={{ __html: app.industry }}>
                                                                                                </h6>
                                                                                                <div className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: app.description }}>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-lg-4">
                                                                                            {app.image && (
                                                                                                <div className="p-2 text-center">
                                                                                                    <img
                                                                                                        src={app.image}
                                                                                                        alt={app.alt || "Application"}
                                                                                                        className="img-fluid rounded"
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>


                                {/* WHY CHOOSE SECTION */}
                                {
                                    product.sections
                                        .filter(section => section.id === "why-choose")
                                        .map(section => (
                                            <section key={section.id} className="why-choose-section mt-4">
                                                <h5 className="text-blue fw-bold mb-3">{section.title}</h5>

                                                <div
                                                    className="why-choose-content"
                                                    dangerouslySetInnerHTML={{ __html: section.content }}
                                                />
                                            </section>
                                        ))
                                }



                            </div>


                            {/* <img src={product.graph} alt={product.name} className="img-fluid p-3 rounded-20" />             */}
                            {/* <CapacityGraph /> */}

                            <div className="product-details-slider px-lg-4">
                                <h3 className="fw-bold my-4">Similar Products</h3>
                                <Swiper
                                    ref={swiperRef}
                                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                                    modules={[Autoplay, Navigation]}
                                    autoplay={{
                                        delay: 2000,
                                        disableOnInteraction: false,
                                    }}
                                    speed={1000}
                                    loop={true}
                                    slidesPerView={4}
                                    spaceBetween={20}
                                    navigation={{ nextEl: ".details-next", prevEl: ".details-prev" }}
                                    breakpoints={{
                                        320: { slidesPerView: 2 },
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 2 },
                                        992: { slidesPerView: 3 },
                                    }}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    {productData.map((product, index) => (
                                        <SwiperSlide key={product.category}>
                                            <div
                                                className={`${index % 2 === 0 ? "even-card" : "odd-card"
                                                    } p-md-3 p-1 product-slide-card rounded-15 text-center my-3`}
                                            >
                                                <Link
                                                    to={`/product-details/${product.category}`}
                                                    className="text-decoration-none"
                                                >
                                                    <div className="d-flex flex-column h-100 p-1 p-md-4 justify-content-between">

                                                        <h5 className="fw-bold text-white mb-md-3 mb-0">{product.name}</h5>
                                                        <div className="d-flex justify-content-center">
                                                            <p
                                                                className="product-capacity text-start fs-sm-10 mb-md-2 mb-0"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: product.detail,
                                                                }}
                                                            />
                                                        </div>

                                                        <img
                                                            src={product.image}
                                                            alt={product.name}
                                                            className="card-img-top"
                                                        />

                                                        <a
                                                            href={product.brochure}
                                                            download={product.brochureName}
                                                            className="btn btn-outline-primary download-brochure mt-2 d-flex align-items-center mx-auto fs-sm-10"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                openBrochureForm(
                                                                    product.brochure,
                                                                    product.brochureName,
                                                                    product.name
                                                                );
                                                            }}
                                                        >
                                                            Download Brochure <FaArrowDown className="ms-2" size={14} />
                                                        </a>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <div className="swiper-navigation mt-3 d-flex justify-content-center gap-3">
                                    <button className="details-prev btn btn-outline-light">Previous</button>
                                    <button className="details-next btn btn-outline-light">Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* brochure form popup */}
            {showFormPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <div className="popup-header d-flex justify-content-center align-items-center">
                            <h5>Download Brochure</h5>
                            <button
                                className="btn-close fs-4"
                                onClick={closeBrochureForm}
                            >
                                ×
                            </button>
                        </div>
                        <div className="form-container">
                            <form onSubmit={handleSubmit}>
                                <div className="input-group flex-column">
                                    {/* Full Name */}
                                    <label className="fw-medium">
                                        Name <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-wrapper rounded-20 my-1 p-2">
                                        <div className="d-flex align-items-center">
                                            <User size={20} className="input-icon text-blue me-2" />
                                            <input
                                                id="brochure-fullName"
                                                name="fullName"
                                                type="text"
                                                placeholder="Enter your name"
                                                className="form-control border-start rounded-0 ps-2"
                                                required
                                                value={formData.fullName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <label className="fw-medium">
                                        Email <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-wrapper rounded-20 my-1 p-2">
                                        <div className="d-flex align-items-center">
                                            <Mail size={20} className="input-icon text-blue me-2" />
                                            <input
                                                id="brochure-email"
                                                name="email"
                                                type="email"
                                                placeholder="Enter your email"
                                                className="form-control border-start rounded-0 ps-2"
                                                required
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Phone */}
                                    <label className="fw-medium">Phone</label>
                                    <div className="input-wrapper rounded-20 my-1 p-2">
                                        <div className="d-flex align-items-center">
                                            <Phone size={20} className="input-icon text-blue me-2" />
                                            <input
                                                id="brochure-phone"
                                                name="phone"
                                                type="tel"
                                                placeholder="Enter your phone number"
                                                className="form-control border-start rounded-0 ps-2"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Delete",
                                                        "Tab",
                                                        "Home",
                                                        "End",
                                                        "+",
                                                        "-",
                                                        "(",
                                                        ")",
                                                        " ",
                                                    ];
                                                    const isNumber = /^[0-9]$/.test(e.key);
                                                    const isAllowed = allowedKeys.includes(e.key);
                                                    if (!isNumber && !isAllowed) e.preventDefault();
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Message */}
                                    <label className="fw-medium mt-3">Message</label>
                                    <div className="input-wrapper rounded-20 my-1 p-2">
                                        <textarea
                                            id="brochure-message"
                                            name="message"
                                            placeholder="Your Message"
                                            rows="4"
                                            className="form-control rounded-0 ps-2"
                                            required
                                            value={formData.message}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/* Submit */}
                                    <div className="d-flex justify-content-center">
                                        <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                                            {loading ? "Sending..." : "Submit"}
                                        </button>
                                    </div>
                                </div>
                                {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* thank you popup */}
            {showThankYouPopup && (
                <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
                    <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
                        <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
                            <h5 className="mb-3 fw-bold text-blue fs-3">Thank you for reaching out to us.</h5>
                            <p> You can also contact PREMIER at <a href='mailto:support@premierpumps.com' >support@premierpumps.com</a></p>
                            <button
                                className="btn btn-primary mt-3 px-4"
                                onClick={() => setShowThankYouPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* thank you popup */}
        </div >
    );
}

export default ProductDetails;
